<!-- eslint-disable vue/no-v-html -->
<template>
    <SearchElastic
        ref="select"
        :placeholder="placeholder"
        :filters="{ university_id: institutionId }"
        :empty-results="emptyResult"
        :search-context="['schools']"
        cache-initial-results
    >
        <template #option="{ option }">
            <div :class="[option.highlight?.name ? 'text-slate-400' : 'text-slate-600', 'leading-5 text-base']">
                <span
                    class="leading-6"
                    v-html="option.highlight?.name ? renderHighlightedName(option.highlight?.name[0]) : option.name"
                >
                </span>
            </div>
            <div class="text-slate-400 leading-5 text-sm">{{ option.university_name }}, {{ option.city_name }}</div>
        </template>
    </SearchElastic>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
    name: 'SelectSchool',
    props: {
        /**
         * Select component placeholder text
         */
        placeholder: {
            type: String,
            default: '',
        },
        /**
         * Translation for empty results message
         */
        emptyResults: {
            type: String,
            required: true,
        },
        /**
         * uni id of the institution to filter schools by
         */
        institutionId: {
            type: Number,
            default: undefined,
        },
    },

    setup() {
        const select = ref<{
            doSearch: () => void;
            renderHighlightedName: (name: string) => string;
            keyword: string;
        } | null>(null);

        onMounted(() => {
            if (select.value) {
                select.value.doSearch();
            }
        });

        return {
            select,
        };
    },
    computed: {
        emptyResult() {
            return `${this.emptyResults} ${this.select?.keyword}`;
        },
    },
    methods: {
        renderHighlightedName(name: string) {
            return this.select?.renderHighlightedName(name);
        },
    },
});
</script>
